import { render, staticRenderFns } from "./EvaluationList.vue?vue&type=template&id=879ddd0e&scoped=true"
import script from "./EvaluationList.vue?vue&type=script&lang=js"
export * from "./EvaluationList.vue?vue&type=script&lang=js"
import style0 from "./EvaluationList.vue?vue&type=style&index=0&id=879ddd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879ddd0e",
  null
  
)

export default component.exports